module.exports = __webpack_public_path__ + "static/img/glxt_01.c830c269.png";